// Checks if the current active element is a text input or ProseMirror editor
// that should block keyboard shortcuts. Returns true if the user is typing.
function isTextInputElement(element: Element): boolean {
   const tagName = element.tagName;
   return tagName === 'INPUT' || tagName === 'TEXTAREA';
}

function isProseMirrorEditor(element: Element): boolean {
   return element.classList?.contains('ProseMirror');
}

export function isUserTyping(): boolean {
   const activeElement = document.activeElement;

   if (!activeElement) {
      return false;
   }

   return isTextInputElement(activeElement) || isProseMirrorEditor(activeElement);
}
